import { render, staticRenderFns } from "./SearchParentContainer.vue?vue&type=template&id=701c1cc2&"
import script from "./SearchParentContainer.vue?vue&type=script&lang=js&"
export * from "./SearchParentContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports